

<app-display-projects-card-view [allProjectsSetter]="allProjects" *ngIf="renderNow" >
</app-display-projects-card-view>



